import { useUIStore } from '@/store/uiStore';
import { useEffect, useRef } from 'react';

export default function ExtensionDialog() {
  const dialog = useUIStore((s) => s.dialog);
  const closeDialog = useUIStore((s) => s.closeDialog);
  const backdropRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!dialog) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDialog(null);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [dialog, closeDialog]);

  if (!dialog) return null;

  const buttons = dialog.buttons?.length ? dialog.buttons : ['OK'];

  return (
    <div
      ref={backdropRef}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50"
      onClick={(e) => {
        if (e.target === backdropRef.current) closeDialog(null);
      }}
    >
      <div className="bg-[#1e1e2e] border border-[#313244] rounded-lg shadow-xl min-w-[320px] max-w-[480px] p-6">
        <h3 className="text-sm font-semibold text-[#cdd6f4] mb-2">{dialog.title}</h3>
        <p className="text-xs text-[#a6adc8] mb-5 whitespace-pre-wrap">{dialog.message}</p>
        <div className="flex justify-end gap-2">
          {buttons.map((label) => (
            <button
              key={label}
              autoFocus={label === dialog.defaultButton}
              onClick={() => closeDialog(label)}
              className={`px-3 py-1.5 text-xs rounded transition-colors ${
                label === dialog.defaultButton
                  ? 'bg-[#89b4fa] text-[#1e1e2e] hover:bg-[#74c7ec]'
                  : 'bg-[#313244] text-[#cdd6f4] hover:bg-[#45475a]'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
